import { Service } from '../models/service.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortConfiguration } from '../components/generics/data-table/data-table.component';
import { UtilsService } from './utils.service';
import { ID } from '../models/ID.model';

@Injectable({
    providedIn: 'root'
})
export class ServicesService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService
    ) { }

    getServices(page: number, itemsPerPage: number, sorts: SortConfiguration[], extraParams: any) {
        const url = '/servicios';
        const headers = {
            'page-number': String(page),
            'page-size': String(itemsPerPage)
        };
        const params = {
            'sort-by': this.utilsService.generateSortQueryParam(sorts)
        };

        Object.assign(params, JSON.parse(JSON.stringify(extraParams)));

        return this.http.get<Service[]>(url, { headers, observe: 'response', params });

    }

    deleteService(serviceId: ID) {
        return this.http.delete(`/servicios/${serviceId}`);
    }

    getServiceById(id: ID) {
        return this.http.get<Service>(`/servicios/${id}`);
    }

    createService(service: Service) {
        return this.http.post<Service>(`/servicios`, service);
    }

    editService(service: Service) {
        return this.http.put<Service>(`/servicios/${service.id}`, service);
    }

    updateMultipleServiceConfigurations(idOficinas: ID[], idServicio: ID, pricing: number, porcentaje: number, topeMaximo: number, topeMinimo: number, descuentoContado: number, descuentoFinanciado: number) {
        return this.http.put(`/servicios/configuraciones/${idServicio}`, { idOficinas, pricing, porcentaje, topeMaximo, topeMinimo, descuentoContado, descuentoFinanciado });
    }

}
